// extracted by mini-css-extract-plugin
export default {"icon":"icon--_M8BH"};